import React, { Component, Fragment } from 'react';
import './login-modal.style.css';
import { connect } from 'react-redux';
import { setLoginFormValidated } from '../../../../actions/login-modal.action';
import { closeModal } from '../../../../actions/app-modal.action';
import { generateOtp } from '../../../../actions/authorization.action';
import { AlertMessageModalConstant } from '../../../../constants/alert-message.constant';
import UtilService from '../../../../services/util.service';
import LoginModalService from '../../../../services/login-modal.service';
import { checkRedirection } from '../../../../actions/dnd-app.action';


class LoginModal extends Component {

    checkNumberValidationWithLength = (event, length) => {
        UtilService.checkNumberValidationWithLength(event, length);
    }

    onChangeMobile = (event) => {
        const { setLoginFormValidated } = this.props;
        if (event && event.target && event.target.value) {
            const value = event.target.value;
            if (LoginModalService.validateMobileNumber(value)) {
                const validForm = { valid: true, userId: value };
                setLoginFormValidated(validForm);
            }
            else {
                const validForm = { valid: false, userId: '' };
                setLoginFormValidated(validForm);
            }
        }
    }

    onClickHandler = () => {
        this.props.generateOtp();
    }

    disableButton = () => {
        const { checkUserApiStatus, generateOtpApiStatus, loginFormValidated } = this.props;
        return LoginModalService.disableButton(checkUserApiStatus, generateOtpApiStatus, loginFormValidated);
    }

    getButtonValue = () => {
        const { checkUserApiStatus, generateOtpApiStatus } = this.props;
        return LoginModalService.getButtonValue(checkUserApiStatus, generateOtpApiStatus);
    }

    closeModal = () => {
        this.props.closeModal();
        this.props.checkRedirection()
    }

    render() {
        const { modalTitle, invalidAirtelNumber, otpSentFailed, otpSentFailedMessage } = this.props;
        return (
            <Fragment>
                <div className="modal-header">
                    <h3 className="margin-top-0 ng-isolate-scope">{modalTitle}</h3>
                    <a className="close" href="javascript:void(0)" onClick={() => this.closeModal()}><i className="icon-outlined-cross"></i></a>
                </div>
                <div className="modal-body">
                    <form name="LoginForm" onSubmit={event => event.preventDefault()} noValidate>
                        <div className="form-group small mb-30">
                            <label className="field-title" data-i18n="mobile_number" module-id="common">Mobile Number</label>
                            <div className="input-group width-full">
                                <span className="input-group-addon fs-20 display-inline-block country_code">+91</span>
                                <input onKeyPress={(event) => this.checkNumberValidationWithLength(event, 9)} onChange={this.onChangeMobile} className="width-full fs-20 " type="number" name="mobileNumber" required placeholder="Enter your number" autoComplete="off" />
                            </div>
                            {invalidAirtelNumber && <p className="small color-dark-orange pt-10">{AlertMessageModalConstant.INVALID_AIRTEL_NUMBER}</p>}
                            {otpSentFailed && <p className="small color-dark-orange pt-10">{otpSentFailedMessage}</p>}
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <div className="action margin-top-20">
                        <button type="button" className="btn ng-isolate-scope" onClick={() => this.onClickHandler()} autoFocus="" disabled={this.disableButton()}>
                            {this.getButtonValue()}
                        </button>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    setLoginFormValidated: data => dispatch(setLoginFormValidated(data)),
    closeModal: () => dispatch(closeModal()),
    generateOtp: () => dispatch(generateOtp()),
    checkRedirection: () => dispatch(checkRedirection())
})

const mapStateToProps = state => {
    return {
        modalName: state.modalInfo.activeModal.modalName,
        modalTitle: state.modalInfo.activeModal.modalTitle,
        checkUserApiStatus: state.loginModalInfo.checkUserApiStatus,
        generateOtpApiStatus: state.loginModalInfo.generateOtpApiStatus,
        generateOtpApiResponse: state.loginModalInfo.generateOtpApiResponse,
        invalidAirtelNumber: state.loginModalInfo.invalidAirtelNumber,
        loginFormValidated: state.loginModalInfo.loginFormValidated,
        otpSentFailed: state.loginModalInfo.otpSentFailed,
        otpSentFailedMessage: state.loginModalInfo.otpSentFailedMessage
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);